var exports = {
  "de": "PopoverContainer__riJpgc",
  "xZ": "OptInPopoverContent__Kf0aty",
  "DZ": "Heading__C1ADSH",
};

module.exports = exports;
